import * as React from "react";
import Component from "../../AbstractComponent";

import { PromptDialog } from "./PromptDialog";
import { PageTransition } from "../Spinner/PageTransition";
import TextField from "../../Partials/Material/TextField";
import Formatter from "../../../Localization/Formatter";

import Constants from "../../../Action/Constants";


export class SavingsCompanyDialog extends Component {
  protected timer;

  public state = {
    entity: null,
    isOpen: false,
    savingsType: "",
    isSaving: false,
    amount: "",
    amountWithdrawal: "",
    financialStatement: null,
    };

  constructor(public props) {
    super(props);
  }

  public componentWillReceiveProps(nextProps) {
    if (nextProps.entity !== this.state.entity) {
      this.setState({
        entity: nextProps.entity
      });
    }

    if (nextProps.isOpen !== this.state.isOpen) {
      this.setState({
        isOpen: nextProps.isOpen
      });
    }

    if (nextProps.savingsType !== this.state.savingsType) {
      this.setState({
        savingsType: nextProps.savingsType
      });
    }

    if (nextProps.financialStatement !== this.state.financialStatement) {
      this.setState({
        financialStatement: nextProps.financialStatement
      });
    }

    if (nextProps.amountWithdrawal !== this.props.amountWithdrawal) {
      this.setState({
        amountWithdrawal: nextProps.amountWithdrawal,
        amount: nextProps.amountWithdrawal || ""
      });
    }
  }

  public onCloseDialog = () => {
    if(this.props.closeDialog){
      this.props.closeDialog();

      this.clearState();
    }
  }

  public componentWillUnmount() {
    this.setState({
      entity: null,
      isOpen: false,
      savingsType: "",
      isSaving: false,
      amount: ""
    })
  }

  public clearState = () => {
    this.setState({
      entity: null,
      isOpen: false,
      savingsType: "",
      isSaving: false,
    })
    
    this.props.dispatch({
      type: Constants.PAGE_CONTACT_COMPANY_UPDATE_CLEAR
    })
  }

  public save = () => {
    if(!this.state.entity) {
      return;
    }

    switch(this.state.savingsType) {
      case "withdrawal": 
        return this.withdrawalFromSavingAccount(this.state.entity);
      // case "payment": 
      //   return this.settleWithSavingsPayment(this.state.entity);
      default:
        break; 
      }
  }

  public withdrawalFromSavingAccount = (company) => {
    this.setState({
      isSaving: true
    });
    this.props.dispatch({
      type: Constants.GLOBAL_WITHDRAWAL_FROM_SAVINGS_ACCOUNT_START,
      payload: {
        companyId: company.id,
        amount: parseFloat(parseFloat(String(Formatter.deleteExtraSpace(this.state.amountWithdrawal)).replace(",", ".")).toFixed(2)),
        // firstDate: (this.props.financialStatement && this.props.financialStatement?.firstDate) ?? null,
        // SavingsCompanyDialog is only used in CompanyUpdate, from which financialStatement is not passed
        // Further, we should make it easy for the user. The user can move savings related charges to another statement period, if necessary.
      },
      onSuccess: () => {
        this.setState({
          isSaving: false,
        });

        this.props.dispatch({
          type: Constants.SNACKBAR_ADD_MESSAGE,
          payload: {
            message: this.trans("snackbar-widhdrawal-amount-from-company-successfully"),
            type: "success"
          }
        });

        this.onCloseDialog();
        if (typeof this.props.initializePage === "function") {
          return this.props.initializePage.call(this, this.props.financialStatement?.id)
        }
      },
      onError: () => {
        this.setState({
          isSaving: false,
        });
      }
    });
  }

  public changeAmountWithdrawal = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);
    if (typeof this.props.changeWithdrawalAmount === "function") {
      return this.props.changeWithdrawalAmount.call(this, amount);
    }

    return this.setState({
      amountWithdrawal: amount,
      amount: amount
    });
  }

  public renderWithdrwalContent = () => {
    let infoText = this.trans("dialog/preprocess-info/withdrawal", {companyName: this.state.entity?.name, savingsAmount: this.formatter.formatNumber(this.state.entity?.savingsAccount, this.props.app.settings.user.currency)});
      return (
        <div>
          {
            this.state.entity?.isAgency ? 
            <div className="hint-styles-dialog">{infoText}</div>
            :
            <div className="hint-styles-dialog">{infoText}</div>
          }
          <TextField
            autoComplete="off"
            className="form-element full-size scroll-to-amount"
            type="text"
            label={this.trans("label-amount")}
            value={this.state.amount}
            onChange={this.changeAmountWithdrawal}
            variant="standard"
            autoFocus={!!this.props.autoFocusAmount}
            error={!!this.getErrorFor("amount")}
          />
          {!!this.getErrorFor("amount") &&  <div className="component-error-text">{this.getErrorFor("amount")}</div>}
        </div>
      );
  }

  public render() {
    return (
      <div>
        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.isOpen}
          title={this.trans("dialog/preprocess-withdrawal/title")}
          content={this.state.savingsType === "withdrawal" ? this.renderWithdrwalContent() : ""}
          positiveButtonLabel={this.trans("dialog-button/continue")}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          onSave={this.save}
          onDiscard={() => this.onCloseDialog()}
        />
                
        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}
